<p-toast></p-toast>

<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [dismissableMask]="true"
  [showHeader]="false"
  styleClass="clarity-call-modal"
  [style]="{ width: '930px', 'max-width': '95vw', 'border-radius': '35px', border: 'none', 'box-shadow': 'none' }"
  (onHide)="close()">

  <div
    class="relative text-white flex flex-column justify-content-center p-4 md:p-6"
    style="width: 100%; min-height: 650px; background: linear-gradient(223deg, #000086 0%, #0909A8 100%); border-radius: 35px; overflow: hidden;">

    <!-- Close button -->
    <button
      pButton
      icon="pi pi-times"
      class="p-button-rounded p-button-text p-button-plain absolute text-white"
      style="top: 16px; right: 16px; font-size: 1.5rem; z-index: 10;"
      (click)="close()">
    </button>

    <!-- Graphic -->
    <img
      src="assets/images/clarity-call-plane.png"
      class="absolute hidden md:block"
      style="left: 721px; top: 183px; width: 207px; height: 466px; object-fit: contain; z-index: 5;"
      alt="Paper Plane">

    <div class="relative z-1" style="margin-bottom: 40px; margin-top: 15px;">
      <h2
        class="text-4xl md:text-6xl m-0 mb-4"
        style="color: #FDFF77; font-family: 'Poppins', sans-serif; font-weight: 700; line-height: 1.2;"
        [innerHTML]="displayHeadline">
      </h2>

      <p
        class="m-0 text-lg md:text-xl"
        style="color: #FFFFFF; font-family: 'Poppins', sans-serif; font-weight: 300; line-height: 1.62; width: 544px; max-width: 100%;">
        {{ displayBody }}
      </p>
    </div>

    <div
      class="relative bg-white w-full"
      style="border: 7px solid #CDD12A; border-radius: 14px; height: 225px; z-index: 10; box-shadow: -6px 6px 0px #CDD12A;">

      <textarea
        pInputTextarea
        [(ngModel)]="query"
        [placeholder]="displayPlaceholder"
        class="w-full border-none outline-none resize-none p-4"
        style="border-radius: 7px; box-shadow: none; font-size: 18px; color: #666; width: 100%; height: calc(100% - 60px); background: transparent;">
      </textarea>

      <div class="absolute" style="bottom: 16px; right: 16px;">
        <button
          pButton
          [label]="isSending ? '' : displayCta"
          [icon]="isSending ? 'pi pi-spin pi-spinner' : (isDirectApplyContext ? 'pi pi-arrow-right' : '')"
          iconPos="right"
          class="font-bold border-none"
          style="background-color: #8B5CF6; color: white; border-radius: 8px; padding: 10px 32px; font-size: 16px;"
          [disabled]="!query.trim() || isSending"
          (click)="send()">
        </button>
      </div>
    </div>

  </div>
</p-dialog>
